import {
    DashboardWidget,
    WidgetBody,
    WidgetDataPoint,
    WidgetFooter,
    WidgetHeader,
    WidgetSkeleton,
    WidgetType
} from "@flexinet/ui-components";
import {NavLink} from "react-router-dom";

interface PaymentMethodWidgetProps {
    activeCount: number;
    totalCount: number;
    hasActiveProfile: boolean;
    loading: boolean;
    customerId: string;
}

export const PaymentMethodWidget = ({activeCount, totalCount, hasActiveProfile, loading, customerId}: PaymentMethodWidgetProps) => {

    if (loading) {
        return <WidgetSkeleton/>;
    }

    const dataPoints: WidgetDataPoint[] = [
        {
            value: activeCount,
            label: hasActiveProfile
                ? `${activeCount} active of ${totalCount} total`
                : 'No active payment method',
            color: hasActiveProfile ? 'green' : 'red',
        },
    ];

    const widget: WidgetType = {
        header: {
            title: 'Payment Profiles',
        },
        body: {
            dataPoints,
            metrics: [],
        },
        footer: {
            actionItems: [
                {
                    label: 'Manage Profiles',
                    component: {NavLink},
                    to: `/customers/${customerId}#tab=Payment Profiles`,
                    visible: true,
                },
            ],
        },
    };

    return (
        <DashboardWidget
            header={<WidgetHeader {...widget.header}/>}
            body={<WidgetBody {...widget.body}/>}
            footer={<WidgetFooter {...widget.footer}/>}
        />
    );
};
